function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Stack =
/*#__PURE__*/
function () {
  function Stack() {
    _classCallCheck(this, Stack);

    this.stack = [];
  }
  /**
   * Pushes an element to the stack.
   *
   * @param {*} element - Whatever you like
   */


  _createClass(Stack, [{
    key: "push",
    value: function push(element) {
      this.stack.push(element);
    }
    /**
     * Pops the last element from the stack.
     *
     * @return {*} The last element on the stack
     */

  }, {
    key: "pop",
    value: function pop() {
      return this.stack.pop();
    }
    /**
     * Returns the top element from the stack (without removing it).
     *
     * @return {*} The last element on the stack
     */

  }, {
    key: "peek",
    value: function peek() {
      return this.stack[this.stack.length - 1];
    }
    /**
     * Utility method to see if the stack is empty or not.
     *
     * @return {Boolean} Whether the stack is empty or not
     */

  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !this.stack.length;
    }
  }]);

  return Stack;
}();

export { Stack as default };